import React from 'react';
import { t } from '@lingui/macro';
import styled, { keyframes } from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import color from '@decisiv/design-tokens/lib/color';

const shimmer = keyframes`
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
`;

const Wrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Panel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: 1px solid ${toColorString(color.base.fullMoon)};
  border-radius: 4px;
  padding: 12px 14px;
`;

const Bar = styled.div`
  height: ${({ height }) => height || '14px'};
  width: ${({ width }) => width || '100%'};
  border-radius: 6px;
  background: linear-gradient(
    90deg,
    ${toColorString(color.base.fullMoon)} 25%,
    ${toColorString(color.base.halfMoon)} 37%,
    ${toColorString(color.base.fullMoon)} 63%
  );
  background-size: 400% 100%;
  animation: ${shimmer} 1.3s ease infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

// Placeholder shaped like ExecutionModalAccordion's three expanded panels
// (Invocation Payload, Input, Output) shown while the detail payload loads.
export default function PayloadSkeleton() {
  return (
    <Wrap
      role="status"
      aria-label={t`Loading payloads...`}
      data-testid="payload-skeleton"
    >
      {['invocation', 'input', 'output'].map((id) => (
        <Panel key={id} aria-hidden="true">
          <Bar width="180px" />
          <Bar height="56px" />
        </Panel>
      ))}
    </Wrap>
  );
}
